export const isValidJsonProcessingPattern = (pattern: string | null) =>
    (typeof pattern === 'string' && !!pattern.length) || pattern === null;